import React, {Component} from 'react';
import {withApplicationContext} from "../../../contexts/ApplicationContext"
import {
    SectionContainer,
    SectionTitle,
    SectionBody, CenterCol,
    Brand
} from "./style.jsx";
import {Container, Row, Col} from 'react-bootstrap';

class AboutUs extends Component {
    render() {
        const {applicationContext} = this.props;
        return (
            <SectionContainer bg={"white"} id={"section-about"}>
                <Container>
                    <SectionTitle><div className={"wrapper"}>{applicationContext.translator("About")}</div></SectionTitle>
                    <SectionBody>
                        <Row>
                            <Col xs={12} md={8} dangerouslySetInnerHTML={{__html: applicationContext.translator("About us text")}} >
                            
                            </Col>
                            <CenterCol xs={12} md={4}>
                                <div>
                                    <Brand>
                                        <img src={"/assets/img/trust-wallet.jpeg"} alt="Trust Wallet" loading="lazy" />
                                        <h6>{applicationContext.translator("The most trusted & secure crypto wallet")}</h6>
                                    </Brand>
                                </div>
                            </CenterCol>
                        </Row>
                    </SectionBody>

                </Container>
            </SectionContainer>

        );
    }
}

export default withApplicationContext(AboutUs);